import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["digit", "hiddenInput", "submitBtn"]

  connect() {
    this.digitTargets[0]?.focus()
  }

  handleInput(event) {
    const input = event.target
    const value = input.value

    if (value.length > 0) {
      // Move to next input
      const nextInput = input.nextElementSibling
      if (nextInput && nextInput.matches("[data-otp-input-target='digit']")) {
        nextInput.focus()
        nextInput.select()
      }
    }

    this.updateHiddenInput()
  }

  handleKeydown(event) {
    const input = event.target

    if (event.key === "Backspace" && input.value === "") {
      // Move to previous input
      const prevInput = input.previousElementSibling
      if (prevInput && prevInput.matches("[data-otp-input-target='digit']")) {
        prevInput.focus()
        prevInput.select()
      }
    } else if (event.key === "ArrowLeft") {
      const prevInput = input.previousElementSibling
      if (prevInput && prevInput.matches("[data-otp-input-target='digit']")) {
        prevInput.focus()
        prevInput.select()
      }
    } else if (event.key === "ArrowRight") {
      const nextInput = input.nextElementSibling
      if (nextInput && nextInput.matches("[data-otp-input-target='digit']")) {
        nextInput.focus()
        nextInput.select()
      }
    }
  }

  updateHiddenInput() {
    const otp = this.digitTargets.map(input => input.value).join("")
    if (this.hasHiddenInputTarget) {
      this.hiddenInputTarget.value = otp
    }

    // Enable/disable submit button
    if (this.hasSubmitBtnTarget) {
      this.submitBtnTarget.disabled = otp.length !== 5
    }
  }
}

